var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99979 1.04175C7.81366 1.04175 6.04145 2.81395 6.04145 5.00008C6.04145 7.18621 7.81366 8.95842 9.99979 8.95842C12.1859 8.95842 13.9581 7.18621 13.9581 5.00008C13.9581 2.81395 12.1859 1.04175 9.99979 1.04175ZM7.29145 5.00008C7.29145 3.50431 8.50401 2.29175 9.99979 2.29175C11.4956 2.29175 12.7081 3.50431 12.7081 5.00008C12.7081 6.49585 11.4956 7.70842 9.99979 7.70842C8.50401 7.70842 7.29145 6.49585 7.29145 5.00008Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99979 10.2084C8.07183 10.2084 6.29556 10.6467 4.97933 11.387C3.68269 12.1164 2.70812 13.2218 2.70812 14.5834L2.70806 14.6684C2.70712 15.6366 2.70594 16.8517 3.7718 17.7197C4.29635 18.1469 5.03018 18.4506 6.02163 18.6513C7.01584 18.8525 8.31164 18.9584 9.99979 18.9584C11.6879 18.9584 12.9837 18.8525 13.9779 18.6513C14.9694 18.4506 15.7032 18.1469 16.2278 17.7197C17.2936 16.8517 17.2924 15.6366 17.2915 14.6684L17.2915 14.5834C17.2915 13.2218 16.3169 12.1164 15.0202 11.387C13.704 10.6467 11.9277 10.2084 9.99979 10.2084ZM3.95812 14.5834C3.95812 13.874 4.47593 13.1044 5.59215 12.4765C6.68878 11.8596 8.24585 11.4584 9.99979 11.4584C11.7537 11.4584 13.3108 11.8596 14.4074 12.4765C15.5236 13.1044 16.0415 13.874 16.0415 14.5834C16.0415 15.6733 16.0079 16.2868 15.4385 16.7504C15.1297 17.0019 14.6135 17.2473 13.73 17.4261C12.8492 17.6044 11.645 17.7084 9.99979 17.7084C8.3546 17.7084 7.1504 17.6044 6.26961 17.4261C5.38606 17.2473 4.86989 17.0019 4.56111 16.7504C3.99172 16.2868 3.95812 15.6733 3.95812 14.5834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.d2ac55d3601c861da4bdc168843a1893.svg";
export { ForwardRef as ReactComponent };